import { useEffect, useState } from 'react';
import { Modal } from "react-bootstrap";
import toast from 'react-hot-toast';
import CustomTextInput from '../../../../components/CustomTextInput';
import { gecersizMailler, mailListesiDuzenle } from '../../../../helpers/mailListesi';

interface Props {
    isShown: boolean
    onSend: (_adres: string) => void
    onClose: () => void
}

/** Ayarlar > Mail Şablonları > Deneme Maili Gönder: ekrandaki (kaydedilmemiş olabilir) konu ve gövde örnek verilerle bu adrese gider. */
const DenemeMailiModal = ({ isShown, onSend, onClose }: Props) => {
    const [adres, setAdres] = useState<string | undefined>('');

    useEffect(() => {
        if (isShown)
            setAdres('');
    }, [isShown])

    const gonder = () => {
        const duzenli = mailListesiDuzenle(adres);

        if (!duzenli) {
            toast.error('E-posta Adresi alanını doldurunuz!');
            return;
        }

        if (duzenli.includes(', ')) {
            toast.error('Tek bir e-posta adresi giriniz.');
            return;
        }

        if (gecersizMailler(duzenli).length > 0) {
            toast.error('Geçersiz e-posta adresi: ' + duzenli);
            return;
        }

        onSend(duzenli);
    }

    return (
        <Modal
            tabIndex={-1}
            dialogClassName='modal-dialog modal-dialog-centered mw-500px'
            show={isShown}
            onHide={onClose}
            backdrop={'static'}
            keyboard={false}
        >
            <div className='modal-header'>
                <h2 className='mb-0'>Deneme Maili Gönder</h2>
            </div>

            <div className='modal-body'>
                <div className='mb-5'>
                    <CustomTextInput labelText='E-posta Adresi' isLabelRequired value={adres} setValue={setAdres} placeholder='ornek@firma.com' />
                </div>

                <div className='alert alert-primary d-flex align-items-start p-4 mb-0'>
                    <i className='fa fa-info-circle text-primary fs-3 me-3 mt-1'></i>
                    <div className='fs-7'>
                        Ekrandaki konu ve gövde (kaydedilmemiş olsa da) örnek verilerle doldurularak bu adrese gönderilir.
                    </div>
                </div>
            </div>

            <div className="modal-footer">
                <button onClick={onClose} type="button" className="btn btn-light">
                    Vazgeç
                </button>
                <button onClick={gonder} type="button" className="btn btn-success">
                    Gönder
                </button>
            </div>
        </Modal>
    )
}

export default DenemeMailiModal;
